import * as React from "react";
let CodeMirrorInstance:any = require("codemirror");

import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import 'codemirror/mode/php/php';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/addon/display/placeholder'

export class CodeMirrorInput extends React.Component<CodeMirrorProps, CodeMirrorState> {
    static defaultProps: Partial<CodeMirrorProps> = {};
    public node:any;
    public codeMirror:any;

    constructor(props: CodeMirrorProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <textarea placeholder={'Put your code here. e.g. return $entry->Field_1;'} onChange={()=>{}} ref={(e)=>this.node=e} style={{width:'100%',height:600}} value={this.props.CustomFieldData.Code}/>
        )
    }


    componentDidMount(): void {

        this.codeMirror = CodeMirrorInstance.fromTextArea(this.node, {
            extraKeys: {"Ctrl-Space": "autocomplete"},
            lineNumbers: true,
            matchBrackets: true,
            autoRefresh: true,
            mode: "text/x-php",
            gutters: ["CodeMirror-lint-markers"],
            lint:true} as any);

        this.codeMirror.on('changes', (instance, change) => {

            this.props.CustomFieldData.Code=instance.doc.getValue()
        });
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface CodeMirrorProps {
    CustomFieldData:CustomFieldData;
}

interface CodeMirrorState {

}

//#endregion "My Region"


export class CustomFieldData {
    Id:number;
    Name:string;
    Code:string;
    FormId:number;
}